import { createI18n } from 'vue-i18n'
import { Locale } from 'vant'

import enUS from 'vant/lib/locale/lang/en-US'
import zhCN from 'vant/lib/locale/lang/zh-CN'
import twCN from 'vant/lib/locale/lang/zh-TW'
import en from './modules/en.json'
import zh from './modules/zh.json'
import tw from './modules/tw.json'

export const supportedLocales = ['zh', 'tw', 'en']
export const normalizeLocale = (lang) => supportedLocales.includes(lang) ? lang : 'zh'
export const initialLocale = normalizeLocale(localStorage.lang)

const messages = {
  en: {
    ...enUS,
    ...en
  },
  tw: {
    ...twCN,
    ...tw
  },
  zh: {
    ...zhCN,
    ...zh
  }
}

export const i18n = new createI18n({
  // 创建i18n实例
  globalInjection: true,
  locale: initialLocale,
  fallbackLocale: 'zh',
  legacy: false,
  messages: messages
})

export const setLocales = (lang) => {
  const locale = normalizeLocale(lang)
  const vantLocales = {
    zh: ['zh-CN', zhCN],
    tw: ['zh-TW', twCN],
    en: ['en-US', enUS]
  }
  Locale.use(...vantLocales[locale])
  localStorage.setItem('lang', locale)
  document.documentElement.lang = { zh: 'zh-CN', tw: 'zh-TW', en: 'en' }[locale]
  return locale
}
